// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"22":"ef360de7","118":"ccc4585e","327":"1600b950","358":"f58bb5e7","431":"40c038ec","473":"fe78643f","518":"4835e8d6","761":"43560d15","765":"87b90690","779":"9cf6fb36"}[chunkId] + ".js";
};